import { Link } from '@mui/material';
import { CheckboxControl, CheckboxControlProps } from '@myhrbox/myhrbox-frontend-core';
import { useTranslation } from 'react-i18next';

interface AgreementCheckboxProps {
  checkboxControlProps?: Partial<CheckboxControlProps>;
}

const AgreementCheckbox = ({ checkboxControlProps }: AgreementCheckboxProps) => {
  const { t } = useTranslation();

  return (
    <CheckboxControl
      rules={{ required: t('confirmUserData.confirmPermission') }}
      name='confirmAgreement'
      label={
        <>
          {t('confirmUserData.agreement.1')}{' '}
          <Link
            href='https://docs.google.com/document/d/1nltBSYJig6bLmnSN6KmiVSDrRmfJl4bCKwfIBKlF7c0/edit?tab=t.0'
            target='_blank'>
            {t('confirmUserData.agreement.2')}
          </Link>{' '}
          {t('confirmUserData.agreement.3')}{' '}
          <Link
            href='https://docs.google.com/document/d/1Q0ygJ1UmfkbXHLW5vX2tI6Rkx8Jv0YY8blyqguw5d9E/edit?tab=t.0'
            target='_blank'>
            {t('confirmUserData.agreement.4')}
            {t('confirmUserData.agreement.5')}
          </Link>
        </>
      }
      {...checkboxControlProps}
    />
  );
};

export default AgreementCheckbox;
